module.exports = __webpack_public_path__ + "img/cloud1-2.f2dc8421.png";